module.exports = __webpack_public_path__ + "static/media/ils-no-error.978de403.svg";